import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Paper } from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import '../../assets/stylesheets/Callsheet.css';
import i18n from '../../i18n';

class DateSelector extends Component {
  render() {
    const { onChangeSelectedDate, selectedDate } = this.props;

    return (
      <Paper className="blockContainer">
        <h5>{i18n.t('callsheet:selectDay')}</h5>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            value={selectedDate}
            onChange={onChangeSelectedDate}
            format="d MMM yyyy"
          />
        </MuiPickersUtilsProvider>
      </Paper>
    );
  }
}

DateSelector.propTypes = {
  selectedDate: PropTypes.instanceOf(Date).isRequired,
  onChangeSelectedDate: PropTypes.func.isRequired
};

export default DateSelector;
